import React, { useEffect } from 'react';
import Devtools from 'mobx-react-devtools';
import { configure } from 'mobx';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { ErrorHandler } from '../common/error-handler';
import { PasswordConfirmationModal } from '../common/password-confirmation-modal';
import { IntranetToggle } from '../common/intranet-toggle';
import { Logger } from '../helpers/Logger';
import { Analytics } from '../helpers/Analytics';
import { GA4 } from '../helpers/GA4';
import { constants } from '../config';
import { Router } from '../routes';
import Modal from '../common/global/modal/component/Modal';
import * as modalGlobal from '../common/global/modal';
import GlobalStyle from '../globalstyles/GlobalStyles';
import { SessionStore } from '../stores/SessionStore';
import whatsapp from '../assets/images/whatsapp.png';
import { ConfigParametersStore } from '../stores/ConfigParametersStore';

Bugsnag.start({
  apiKey: 'fdde94ff1e66c1d1a77deebaceac2d29',
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    event.setUser(localStorage.getItem('token') || 'Usuario incóngnito');
  },
});

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React);

// Log useful startup data
Logger.log('Starting App');
Logger.log(`modal.jsEnvironment: ${constants.environmentName}`);
Logger.log(`Version: ${constants.version}`);

console.log('jeck', constants.environment.isProduction);
if (constants.environment.isProduction) {
  console.log('Init google analytics');
  Analytics.startTracking();
  GA4.injectGoogleAnalytics();
}

// Enable Mobx Strict Mode
configure({
  enforceActions: 'strict',
});

const routeConfigTemplate = {
  name: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

const IPropTypes = {
  routeConfig: PropTypes.arrayOf(PropTypes.shape(routeConfigTemplate)).isRequired,
};

const AppTemplate = (props) => {
  useEffect(() => {
    if (SessionStore.token && !SessionStore.tokenNewApi) {
      SessionStore.logout();
    }
    document.addEventListener('contextmenu', (event) => {
      if (event && event.target && event.target.toString().includes('HTMLImageElement')) {
        modalGlobal.showModal('Recordatorio', `
            <div style="text-align:center;">
            Todo el contenido (imágenes, textos, etc) que forma parte de este Sitio es propiedad de 
            Carlos Gutiérrez S.A o de sus proveedores.</br>
            <b>El usuario solo podrá descargar contenido para su uso privado,</b> sin ningún fin comercial, 
            por lo que no podrá explotar, reproducir, distribuir, modificar, comunicar públicamente, ceder,
            transformar o usar el contenido de la web con fines públicos o comerciales <b>bajo
            apercibimiento de iniciar las acciones civiles y penales pertinente.</b>
            </div>`, true);
      }
    });
  }, []);

  const onError = (event) => {
    console.log('about to send this event', { event });
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorHandler} onError={onError}>
      <div style={{
          position: 'relative',
        }}
      >
        {
          constants.environment.isDevelopment &&
          constants.enableMobxDevtools &&
          <Devtools />
        }
        <GlobalStyle />
        <ToastContainer />
        <IntranetToggle />
        <Router routeConfig={props.routeConfig} />
        <PasswordConfirmationModal />
        <Modal
          ref={(modalRef) => {
            modalGlobal.setTopLevelModal(modalRef);
          }}
        />
        {ConfigParametersStore.isFeatureFlagEnabled('whatsapp-chat') &&
          <div className="whatsapp">
            <a target="_blank" rel="noopener noreferrer" href="https://wa.me/59895036294?text=¡Hola!">
              <img alt="" src={whatsapp} />
            </a>
          </div>
        }
      </div>
    </ErrorBoundary>
  );
};

AppTemplate.propTypes = IPropTypes;

export { AppTemplate };



// WEBPACK FOOTER //
// ./src/apps/AppTemplate.jsx